<template>
  <div
    class="up_down_box"
    :class="[
    styleType == 'typeGreen'
      ? 'up_down_box_green'
      : styleType == 'typeBlue'
        ? 'up_down_box_blue'
        : '',
    isBaoSteel ? 'isBaoSteelClass' : null,
  ]"
  >
    <div class="up_box" :class="[isBaoSteel ? 'isBaoSteel' : null, styleType == 'typeStrong' ? 'isStrong' : null]">
      <div class="door_title">
        <door-title v-if="isRailwayTransport || isWaterWayTransport || isBeltTransport">
          <el-form-item style="margin-top: 5px; margin-right: 0">
            <a v-if="transportLength >= 2 || showTotalTransport" class="tab_btn" :class="{ chooseBtn: chooseBtn == 1 }" @click="selectTab(1)">清洁运输</a>
            <a class="tab_btn" :class="{ chooseBtn: chooseBtn == 2 }" @click="selectTab(2)">车辆运输</a>
            <!--            <a class="" v-if="customerId == 89">铁路运输</a>-->
            <a class="tab_btn" :class="{ chooseBtn: chooseBtn == 3 }" @click="selectTab(3)" v-if="isRailwayTransport">铁路运输</a>
            <a class="tab_btn" :class="{ chooseBtn: chooseBtn == 4 }" v-if="isWaterWayTransport" @click="selectTab(4)">水路运输</a>
            <a class="other_btn" v-if="!isWaterWayTransport && isShowWaterWayTransport">水路运输</a>
            <a class="tab_btn" :class="{ chooseBtn: chooseBtn == 5 }" v-if="isBeltTransport" @click="selectTab(5)">带式运输</a>
            <a class="other_btn" v-if="!isBeltTransport && isShowBeltTransport">带式运输</a>
            <a class="tab_btn" :class="{ chooseBtn: chooseBtn == 6 }" v-if="isPipelineTransport" @click="selectTab(5)">管道运输</a>
            <a class="other_btn" v-if="!isPipelineTransport && isShowPipelineTransport">管道运输</a>
          </el-form-item>
        </door-title>
        <door-title v-else>
          <div v-if="customerId != 41&& customerId != 11">车辆运输统计</div>
          <div v-if="customerId == 11">清洁运输统计</div>
          <div v-if="customerId != 41">
            <el-form-item style="margin-top: 5px; margin-right: 0">
              <a class="other_btn" v-if="isNewCleanTransport && customerId != 95">铁路运输</a>
              <a class="other_btn" v-if="isNewCleanTransport && customerId != 95">水路运输</a>
              <a class="other_btn" v-if="isNewCleanTransport && customerId != 95">带式运输</a>
            </el-form-item>
          </div>
          <div v-else>
            <a class="other_btn" :class="{ chooseBtn: chooseBtn == 1 }" @click="selectTab(1)">清洁运输</a>
            <a class="other_btn" :class="{ chooseBtn: chooseBtn == 2 }" @click="selectTab(2)">车辆运输</a>
          </div>
        </door-title>
        <div class="public-form form_box" v-if="showTransportType === 1">
          <el-form class="public-form" :inline="true">
            <el-form-item label="起止时间">
              <DatePicker
                init-width="420px"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="baseTime"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="base_change"
                :idIndex="2"
              ></DatePicker>
            </el-form-item>
            <el-form-item>
              <a class="self_btn" @click="getTransportAllType">查询</a>
              <a class="self_btn" @click="resetAllForm">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="public-form form_box" v-else-if="showTransportType === 2">
          <el-form class="public-form" :inline="true">
            <el-form-item label="起止时间">
              <DatePicker
                init-width="420px"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="createTime"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="date_change"
                :idIndex="2"
              ></DatePicker>
            </el-form-item>
            <el-form-item>
              <a class="self_btn" @click="searchCountClean">查询</a>
              <a class="self_btn" @click="resetCleanForm">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="public-form form_box" v-if="showTransportType === 3">
          <el-form class="public-form" :inline="true">
            <el-form-item label="起止时间">
              <DatePicker
                init-width="420px"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="railwayDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="time_change"
                :idIndex="2"
              ></DatePicker>
            </el-form-item>
            <el-form-item>
              <a class="self_btn" @click="searchRailwayClean">查询</a>
              <a class="self_btn" @click="resetRailwayForm">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="public-form form_box" v-if="showTransportType === 4">
          <el-form class="public-form" :inline="true">
            <el-form-item label="起止时间">
              <DatePicker
                init-width="420px"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="waterDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="waterTime_change"
                :idIndex="2"
              ></DatePicker>
            </el-form-item>
            <el-form-item>
              <a class="self_btn" @click="searchWaterwayClean">查询</a>
              <a class="self_btn" @click="resetWaterWayForm">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="public-form form_box" v-if="showTransportType === 5">
          <el-form class="public-form" :inline="true">
            <el-form-item label="起止时间">
              <DatePicker
                init-width="420px"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="beltWayDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="beltTime_change"
                :idIndex="2"
              ></DatePicker>
            </el-form-item>
            <el-form-item>
              <a class="self_btn" @click="searchBeltWayClean">查询</a>
              <a class="self_btn" @click="resetBeltWayForm">重置</a>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <door-box>
        <div class="box-wrap" v-show="transportLength >= 2 && showTransportType === 1">
          <div class="left" style="width: 85%">
            <div class="count">
              <div class="smallTitle allTitle" :class="{ 'allTitle-64': customerId == 64 }">运输方式占比</div>
              <div class="chart-desc allchart-desc" :class="{ 'chart-desc-64': customerId == 64 }">
                <div
                  class="desc-item"
                  :class="{ 'desc-item-64': customerId == 64 }"
                  v-for="(percent, index) in allfactory_tPercent"
                  :key="`allpercent-${index}`"
                >
                  <span class="block" :style="{ backgroundColor: getColor_(index) }"></span>
                  <span v-if="customerId == 64">
                    {{
                    percent.trafficTypeName +
                    " " +
                    percent.percentage +
                    "%" +
                    " " +
                    percent.transportVolume.toFixed(1) +
                    "吨"
                    }}
                  </span>
                  <span v-else>
                    {{
                    percent.trafficTypeName + " " + percent.percentage + "%"
                    }}
                  </span>
                </div>
              </div>
            </div>
            <div class="allfactory-bar-chart" :class="(isnewVesionTansDetail || customerId == 50) ? 'bigWidthChart' : ''" ref="allfactoryBarChart"></div>
          </div>
        </div>
        <!--        原车辆运输-->
        <div class="box-wrap" v-if="showTransportType === 2">
          <div class="left" style="width: 100%" v-if="customerId === 6 ||customerId === 11">
            <div class="smallTitle">清洁运输占比</div>
             
            <div class="count">
              <a v-if="customerId === 11" class="download-link" href="https://wx.bmetech.com/screen/saver/JT/2025%E5%B9%B4%E6%B8%85%E6%B4%81%E8%BF%90%E8%BE%93%E6%AF%94%E4%BE%8B.xlsx" target="_blank">
              </a>
              <div class="factory-bar-chart" :class="{'limit-width':customerId === 11}" ref="factoryBarChart"></div>
              <div class="chart-desc" v-if="customerId !== 11">
                <div class="desc-item" v-for="(percent, index) in factory_tPercent" :key="`percent-${index}`">
                  <span class="block" :style="{ backgroundColor: getColor_(index) }"></span>
                  <span>{{ percent.type }}</span>
                </div>
              </div>
               <div class="chart-desc" v-else>
              
                  <div class="desc-item" v-for="(percent, index) in factory_tPercent" :key="`percent-${index}`">
                    <span class="block" :style="{ backgroundColor: getColor_(index) }"></span>
                    <span>{{ percent.type + '  ' + percent.percentage + '%' }}</span>
                  </div>
           
              </div>
            </div>
          </div>
          <div class="left" v-else>
            <div class="smallTitle">
              {{
              customerId == 59 ||
              customerId == 42 ||
              customerId == 64 ||
              customerId == 45 ||
              isWaterWayTransport
              ? "车辆排放类型占比"
              : "清洁运输占比"
              }}
              
            </div>
            <div class="factory-chart" ref="factoryPieChart"></div>
            <div class="chart-desc">
              <div class="cleanTransportTotal desc-item" v-if="customerId == 50" :class="topBylength">
                <p class="p_block"><span class="p_span"></span>清洁运输 {{ cleanTransportTotal }}%</p>
              </div>
              <div class="desc-item" v-for="(percent, index) in factory_tPercent" :key="`percent-${index}`">
                <span class="block" :style="{ backgroundColor: getColor_(index) }"></span>
                <span>{{ percent.type + " " + percent.percentage + "%" }}</span>
              </div>
            </div>
          </div>
          <div class="right" ref="rightBlock" v-if="customerId !== 6 && customerId !== 11">
            <div class="chapter" style="margin-bottom: 20px">
              <door-title>运输货物统计</door-title>
            </div>
            <template v-if="customerId === 35">
              <div class="transport-counts" ref="transportCounts">
                <el-table :height="transportHeight" :data="factory_transportCount" style="width: 100%">
                  <el-table-column prop="type" label="运输方式" align="center">
                    <template #default="scope">
                      <span :title="scope.row.type">{{ scope.row.type }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="frequency" label="运输次数" align="center">
                    <template #default="scope">
                      <span :title="scope.row.frequency">
                        {{
                        scope.row.frequency
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="transportName" label="运输货物" align="center">
                    <template #default="scope">
                      <span :title="scope.row.transportName">
                        {{
                        scope.row.transportName.length > 8
                        ? scope.row.transportName.substr(0, 8) + "..."
                        : scope.row.transportName
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="transportVolume" label="运输总量" align="center">
                    <template #default="scope">
                      <span :title="scope.row.transportVolume">{{ scope.row.transportVolume.toFixed(1) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
            <template v-else>
              <a
                class="self_btn"
                style="
                                    position: absolute;
                                    top: -25px;
                                    right: 10px;
                                    width: 140px;
                                  "
                v-if="isNewCleanTransport"
                @click="moreTransportMaterial"
              >按物料分类</a>
              <div class="transport-counts" style="overflow: hidden; height: auto">
                <div class="transport-header">
                  <span class="method">运输方式</span>
                  <span class="num">运输次数</span>
                  <span class="goods">运输货物</span>
                  <span class="count">运输总量</span>
                </div>
              </div>
              <span class="tool-tip" v-show="showTooltip" :style="{ left: '-50%', top: '60%' }">{{ currentHover }}</span>
              <div class="marquee_box" @mouseover="stopMarquee" @mouseout="startMarquee">
                <div
                  class="transport-counts marquee_list"
                  ref="transportCounts"
                  :class="{ marquee_top: factory_transportCount.length > 1 ? animate : false }"
                >
                  <div class="transport-body" v-for="(count, index) in factory_transportCount" :key="`tran-${index}`">
                    <div class="method" @mouseenter="Tooltip" @mouseout="hideTooltip">
                      <span class="content">{{ count.type }}</span>
                    </div>
                    <div class="number">
                      <span class="content">{{ count.frequency }}</span>
                    </div>
                    <div class="goods" @mouseenter="Tooltip" @mouseout="hideTooltip">
                      <span class="content">{{ count.transportName }}</span>
                    </div>
                    <div class="count">
                      <span class="content">{{ count.transportVolume.toFixed(1) }}{{customerId != 41 ? '吨' : 'kg'}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--        铁路运输-->
        <div class="box-wrap" v-if="showTransportType === 3">
          <div class="center_block" ref="rightBlock">
            <div class="chapter" style="margin-bottom: 20px">
              <door-title>铁路运输分类统计</door-title>
            </div>
            <template v-if="customerId !== 999">
              <a
                class="self_btn"
                style="
                                    position: absolute;
                                    top: -25px;
                                    right: 150px;
                                    width: 140px;
                                  "
                v-if="isNewCleanTransport"
                @click="openRailwayLedger"
              >铁路运输台账</a>
              <a
                class="self_btn"
                style="
                                    position: absolute;
                                    top: -25px;
                                    right: 10px;
                                    width: 140px;
                                  "
                v-if="isNewCleanTransport"
                @click="moreRailwayMaterial"
              >按物料分类</a>
              <div class="transport-counts" style="overflow: hidden; height: auto">
                <div class="transport-header">
                  <span class="vehicleEmissions">排放阶段</span>
                  <span class="transportName">物料名称</span>
                  <span class="transportVolume">重量</span>
                  <span class="frequency">次数</span>
                  <span class="type">类型</span>
                </div>
              </div>
              <span class="tool-tip" v-show="showTooltip" :style="{ left: '0%', top: '80%' }">{{ currentHover }}</span>
              <div class="marquee_box" @mouseover="stopRailwayMarquee" @mouseout="startRailwayMarquee">
                <div class="transport-counts marquee_list" ref="transportCountsWater" :class="{ marquee_top: trainAnimate }">
                  <div class="transport-body" v-for="(count, index) in railway_transportCount" :key="`tran-${index}`">
                    <div class="vehicleEmissions">
                      <span class="content">
                        {{
                        vehicleMissionsName[count.vehicleEmissions]
                        }}
                      </span>
                    </div>
                    <div class="transportName" @mouseenter="Tooltip" @mouseout="hideTooltip">
                      <span class="content">{{ count.transportName }}</span>
                    </div>

                    <div class="transportVolume">
                      <span class="content">{{ count.transportVolume.toFixed(1) }}吨</span>
                    </div>
                    <div class="frequency">
                      <span class="content">{{ count.frequency }}</span>
                    </div>
                    <div class="type">
                      <span class="content">{{ count.type }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- 水路运输 -->
        <div class="box-wrap" v-if="showTransportType === 4">
          <div class="center_block" ref="rightWaterMethod">
            <div class="chapter" style="margin-bottom: 20px">
              <door-title>水路运输统计</door-title>
            </div>
            <template v-if="customerId !== 999">
              <a
                class="self_btn"
                style="
                                    position: absolute;
                                    top: -25px;
                                    right: 150px;
                                    width: 140px;
                                  "
                v-if="isNewCleanTransport"
                @click="openWaterWayLedger"
              >水路运输台账</a>
              <a
                class="self_btn"
                style="
                                    position: absolute;
                                    top: -25px;
                                    right: 10px;
                                    width: 140px;
                                  "
                v-if="isNewCleanTransport"
                @click="moreWaterWayMaterial"
              >按物料分类</a>
              <div class="transport-counts" style="overflow: hidden; height: auto">
                <div class="transport-header">
                  <span class="waterMethods">运输方式</span>
                  <span class="waterTimes">运输次数</span>
                  <span class="waterContents">运输货物</span>
                  <span class="waterNums">运输总量(吨)</span>
                </div>
              </div>
              <span
                class="tool-tip"
                v-show="showTooltip_water"
                @mouseenter.stop="waterTolltipEnterEvent"
                @mouseleave.stop="waterTolltipOutEvent"
                :style="{ left: currentLeft, top: '50%' }"
              >
                {{ currentHover
                }}
              </span>
              <div class="marquee_box">
                <div class="transport-counts marquee_list" ref="transportCounts" :class="{ marquee_top: trainAnimate }">
                  <div class="transport-body" v-for="(item, index) in waterway_transportCount" :key="`water-${index}`">
                    <div class="waterMethods">
                      <span class="content">
                        {{
                        '水路运输'
                        }}
                      </span>
                    </div>
                    <div class="waterTimes">
                      <span class="content">{{ item.frequency }}</span>
                    </div>
                    <div class="waterContents" @mouseenter="toolTip_Water" @mouseout="hideTooltip_Water">
                      <span class="content">{{ item.transportName }}</span>
                    </div>
                    <div class="waterNums">
                      <span class="content">{{ item.transportVolume.toFixed(1) }}吨</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--        带式运输-->
        <div class="box-wrap" v-if="showTransportType === 5">
          <div class="center_block" ref="rightBlock">
            <div class="chapter" style="margin-bottom: 20px">
              <door-title>带式运输分类统计</door-title>
            </div>
            <template v-if="customerId !== 999">
              <a
                class="self_btn"
                style="
                                    position: absolute;
                                    top: -25px;
                                    right: 150px;
                                    width: 140px;
                                  "
                v-if="isNewCleanTransport"
                @click="openBeltwayLedger"
              >带式运输台账</a>
              <div class="transport-counts" style="overflow: hidden; height: auto">
                <div class="transport-header">
                  <span class="vehicleEmissions">排放阶段</span>
                  <span class="transportName">物料名称</span>
                  <span class="transportVolume">重量</span>
                  <span class="frequency">次数</span>
                  <span class="type">类型</span>
                </div>
              </div>
              <span class="tool-tip" v-show="showTooltip && currentHover.length > 8" :style="{ left: '0%', top: '60%' }">{{ currentHover }}</span>
              <div class="marquee_box" @mouseover="stopBeltwayMarquee" @mouseout="startBeltWayMarquee">
                <div class="transport-counts marquee_list" ref="transportCountsWater" :class="{ marquee_top: trainAnimate }">
                  <div class="transport-body" v-for="(count, index) in beltWay_transportCount" :key="`tran-${index}`">
                    <div class="vehicleEmissions" @mouseenter="Tooltip" @mouseout="hideTooltip">
                      <span class="content">
                        {{
                        vehicleMissionsName[count.vehicleEmissions]
                        }}
                      </span>
                    </div>
                    <div class="transportName" @mouseenter="Tooltip" @mouseout="hideTooltip">
                      <span class="content">{{ count.transportName }}</span>
                    </div>

                    <div class="transportVolume">
                      <span class="content">{{ count.transportVolume.toFixed(1) }}吨</span>
                    </div>
                    <div class="frequency">
                      <span class="content">{{ count.frequency }}</span>
                    </div>
                    <div class="type">
                      <span class="content">{{ count.type}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </door-box>
    </div>
    <div class="down_box" :class="[isBaoSteel ? 'isBaoSteel' : null, styleType == 'typeStrong' ? 'isStrong' : null]">
      <div class="door_title">
        <door-title>车辆电子台账</door-title>
        <div class="public-form form_box">
          <el-form class="public-form" :inline="true">
            <el-form-item>
              <el-select v-model="params.vehicleEmissions" placeholder="请选择">
                <el-option v-for="item in vehicleMissionsType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input class="input-style" v-model="params.keyword" style="width: 321px" placeholder="请输入车牌号/车辆识别代号"></el-input>
              <!-- <el-input v-model="params.keyword" placeholder="请输入"></el-input> -->
            </el-form-item>
            <el-form-item>
              <a class="self_btn" @click="searchCarAccount">查询</a>
              <a class="self_btn" @click="resetCarForm">重置</a>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <door-box>
        <div class="public-form form_box" style="display: block; padding: 40px 30px; text-align: right">
          <div class="form">
            <el-form :inline="true">
              <el-radio-group v-model="choosedAccount">
                <el-radio-button :label="carAccountType.inFactory"></el-radio-button>
                <el-radio-button :label="carAccountType.nonMovement"></el-radio-button>
              </el-radio-group>
            </el-form>
            <el-button type="text" @click="gotoList">更多></el-button>
          </div>
          <div class="table_box" style="margin-top: 14px">
            <el-table :data="factoryData" style="width: 100%" height="225px" v-show="showFactoryTable" @row-click="factoryRowClick">
              <el-table-column prop="numberPlate" label="车牌号" align="center"></el-table-column>
              <el-table-column prop="vin" label="车辆识别代号(VIN)" align="center" width="300"></el-table-column>
              <el-table-column prop="engineNumber" label="发动机号码" align="center"></el-table-column>
              <el-table-column prop="vehicleEmissions" label="排放阶段" align="center">
                <template #default="scope">{{ vehicleMissionsName[scope.row.vehicleEmissions] }}</template>
              </el-table-column>
              <el-table-column v-if="customerId == 22" prop="fuelType" label="燃油类型" align="center"></el-table-column>
              <el-table-column label="详情" align="center">查看</el-table-column>
            </el-table>
            <!-- <div class="aaa" style="background:red;width:100px;height:100px" @click="nonMovementRowClick"></div> -->
            <el-table
              :data="nonMovementData"
              style="width: 100%"
              height="225px"
              v-show="showNonMovementTable"
              @row-click="nonMovementRowClick"
            >
              <el-table-column prop="environmentCode" label="环保登记编码" align="center"></el-table-column>
              <el-table-column v-if="customerId == 22" prop="mechanicalEnvironment" label="机械环保代码\环保信息公开编码" align="center" width="310"></el-table-column>
              <el-table-column v-if="customerId !== 22" prop="mechanicalEnvironment" label="机械环保代码" align="center"></el-table-column>
              <el-table-column prop="vehicleEmissions" label="排放阶段" align="center">
                <template #default="scope">{{ vehicleMissionsName[scope.row.vehicleEmissions] }}</template>
              </el-table-column>
              <el-table-column prop="productionDate" label="生产日期" align="center"></el-table-column>
              <!-- <el-table-column v-if="customerId==22" prop="openCode" label="公开编码" align="center"></el-table-column> -->
              <el-table-column v-if="customerId == 22" prop="fuelType" label="燃油类型" align="center"></el-table-column>
              <el-table-column v-if="customerId == 22" prop="mechanicalType" label="机械种类" align="center"></el-table-column>
              <el-table-column label="详情" align="center" width="80px">查看</el-table-column>
            </el-table>
          </div>
        </div>
      </door-box>
    </div>
  </div>
</template>
<script>
import { dateFormat, deteleObject } from '@/utils/tools.js'
import doorBox from '../components/doorBox'
import doorTitle from '../components/doorTitle'
import { getBarSeries, getPieSeries, getPieSeries2 } from './factoryData'
import getCarOpt from './carData'
import { mapState, mapGetters } from 'vuex'
import basic from './../components/doorDialog/basic.vue'
import accountListInFactory from './../components/doorDialog/accountListInFactory.vue'
import accountListNonmove from './../components/doorDialog/accountListNonmove.vue'
import detailPage from './component/buttonPage.vue'
import { DatePicker } from '@/modules/commonDatePicker'
import railwayDetail from 'modules/cleanTransportComponents/components/doorDialog/railwayDetail'
import railwayPage from 'modules/cleanTransportComponents/cleanStatistics/component/railwayPage'
import waterWayDetail from 'modules/cleanTransportComponents/components/doorDialog/waterWayDetail'
import waterWayPage from 'modules/cleanTransportComponents/cleanStatistics/component/waterWayPage'
import beltWayDetail from 'modules/cleanTransportComponents/components/doorDialog/beltWayDetail'
import moment from 'moment'
const VEHICLE_EMISSIONS = {
  emissions4: 3,
  emissions4: 4,
  emissions5: 5,
  emissions6: 6,
  newSource: 99
  // railway: 101,
  // waterway: 102,
  // pipeline: 103,
}
export default {
  name: 'cleanStatistics',
  title: '清洁运输统计',
  components: { doorBox, doorTitle, DatePicker, basic },
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      pageInfo: 'cleanStatistics/index.vue',
      computedName: '清洁运输统计组件',
      showTransportType: 1,
      transportLength: 0,
      chooseBtn: 1,
      styleType: '',
      customerId: this.$store.state.customerId,
      isNewCleanTransport: bmeConfig.isNewCleanTransport,
      showTooltip: false,
      showTooltip_water: false,
      isEnterTooltip: false,
      enterTimer: null, // 定时器 作用于鼠标从tool-tip框到运输货物框
      enterTimer2: null, // 定时器 作用于鼠标从tool-tip框到非运输货物框
      currentLeft: '',
      currentTop: '',
      currentHover: '',
      animate: false,
      trainAnimate: false,
      beltAnimate: false,
      scrollHeight: 0,
      interVal: null,
      railway_transportCount: [],
      waterway_transportCount: [],
      beltWay_transportCount: [],
      railwayInterVal: null,
      beltWayInterVal: null,
      clock: null,
      railwayClock: null,
      waterWayClock: null,
      beltWayClock: null,
      baseTime: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      createTime: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      cleanDate: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      cleanDate_: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', ''],
      railwayDate: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      beltWayDate: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      waterDate: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      railwayDate_: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', ''],
      waterDate_: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', ''],
      beltDate_: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', ''],
      factoryBarChart: null,
      factoryPieChart: null,
      allfactory_tPercent: [],
      factory_tPercent: [],
      allfactory_transportPercent: [],
      factory_transportPercent: [],
      factory_transportCount: [],
      carChart: null,
      car_dimensions: new Set(),
      car_source: [],
      vehicle6InoutCount: 0,
      vehicle5InoutCount: 0,
      newSourceInoutCount: 0,
      params: {
        keyword: '',
        vehicleEmissions: ''
      },
      carAccountType: {
        inFactory: '场内运输车辆电子台账',
        nonMovement: '非道路移动机械电子台账'
      },
      choosedAccount: '场内运输车辆电子台账',
      vehicleMissionsType: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '国I',
          value: 1
        },
        {
          label: '国II',
          value: 2
        },
        {
          label: '国III',
          value: 3
        },
        {
          label: '国IV',
          value: 4
        },
        {
          label: '国V',
          value: 5
        },
        {
          label: '国VI',
          value: 6
        },
        {
          label: '新能源',
          value: 99
        }
        // {
        //   label: "铁路运输",
        //   value: 101,
        // },
        // {
        //   label: "水路运输",
        //   value: 102,
        // },
        // {
        //   label: "管道或管状带式输送机",
        //   value: 103,
        // },
      ],
      vehicleMissionsName: {
        1: '国I',
        2: '国II',
        3: '国III',
        4: '国IV',
        5: '国V',
        6: '国VI',
        99: '新能源',
        101: '铁路运输',
        // 102: "水路运输",
        103: '管道或管状带式输送机'
      },
      showFactoryTable: false,
      factoryData: [],
      baseUrl: bmeConfig.baseUrl,
      showNonMovementTable: false,
      nonMovementData: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      showTotalTransport: bmeConfig.showTotalTransport,
      isRailwayTransport: bmeConfig.isRailwayTransport,
      isWaterWayTransport: bmeConfig.isWaterWayTransport,
      isShowWaterWayTransport: bmeConfig.isShowWaterWayTransport,
      isBeltTransport: bmeConfig.beltTransport,
      isShowBeltTransport: bmeConfig.isShowBeltTransport,
      isPipelineTransport: bmeConfig.isPipelineTransport,
      isShowPipelineTransport: bmeConfig.isShowPipelineTransport,
      transportHeight: 0,
      isBaoSteel: bmeConfig.isBaoSteel,
      isnewVesionTansDetail: bmeConfig.isnewVesionTansDetail,
      cleanTransportTotal: 0,
      topBylength:""
    }
  },
  watch: {
    newAccessType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.carAccountType.inFactory = '厂内运输车辆电子台账'
          this.choosedAccount = '厂内运输车辆电子台账'
        }
      }
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
      },
      deep: true
    },
    choosedAccount(newAccount, oldAccount) {
      switch (newAccount) {
        case this.carAccountType.inFactory:
          this.showTable = this.showNonMovementTable = false
          this.showFactoryTable = true
          break
        case this.carAccountType.nonMovement:
          this.showTable = this.showFactoryTable = false
          this.showNonMovementTable = true
          break
      }
    }
  },
  computed: {
    ...mapState({
      cleanTransportIp: 'cleanTransportIp',
      newAccessType: 'newAccessType'
    }),
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent'
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType
    }
  },
  created() {
    this.styleType = this.$store.state.styleType
    if (this.customerId == 41) {
      this.baseTime = [dateFormat('YYYY-mm-dd HH:MM:SS', new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30)), dateFormat('YYYY-mm-dd HH:MM:SS', new Date())];
      this.createTime = this.cleanDate_ = [dateFormat('YYYY-mm-dd HH:MM:SS', new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30)), dateFormat('YYYY-mm-dd HH:MM:SS', new Date())];
    }
  },
  methods: {
    selectTab(index) {
      this.chooseBtn = index
      this.showTransportType = index
      if (index == 4) {
        this.destoryAllTimeOutAndEcharts()
        // 水路运输接口调用
        this.waterWayRefresh()
      } else if (index == 3) {
        this.destoryAllTimeOutAndEcharts()
        this.railwayRefresh()
      } else if (index == 2) {
        this.destoryAllTimeOutAndEcharts()
        this.refresh()
      } else if (index == 1) {
        this.destoryAllTimeOutAndEcharts()
        this.getTransportAllType()
      } else if (index === 5) {
        this.destoryAllTimeOutAndEcharts()
        this.beltwayRefresh()
      }
    },
    // tab切换，消除所有其它tab的定时器，销毁echart图表
    destoryAllTimeOutAndEcharts() {
      // 清除车辆定时器
      clearTimeout(this.clock)
      // 清除铁路运输定时器
      clearTimeout(this.railwayClock)
      // 清除水路运输定时器
      clearTimeout(this.waterWayClock)
      // 清除带式运输定时器
      clearTimeout(this.beltWayClock)
      // 销毁车辆饼图
      if (this.factoryPieChart) {
        this.factoryPieChart.dispose()
        this.factoryPieChart = null
      }
      // 销毁清洁运输饼图 创建清洁运输饼图的逻辑中会先清空这个饼图
    },
    moreTransportMaterial() {
      this.$store.commit('dialogStatus', true)
      this.$store.commit('updateTransportTime', this.cleanDate)
      this.$popup.open(detailPage, this.dialogCompontent, this, {
        pageTitleName: "清洁运输物料分类列表",})
    },
    openRailwayLedger() {
      this.$store.commit('dialogStatus', true)
      this.$store.commit('updateRailwayTime', this.railwayDate)
      this.$popup.open(railwayDetail, this.dialogCompontent, this, {pageTitleName: "清洁运输铁路运输功能列表",})
    },
    moreRailwayMaterial() {
      this.$store.commit('dialogStatus', true)
      this.$store.commit('updateRailwayTime', this.railwayDate)
      this.$popup.open(railwayPage, this.dialogCompontent, this, {})
    },
    openWaterWayLedger() {
      this.$store.commit('dialogStatus', true)
      this.$store.commit('updateaWterWayTime', this.waterDate)
      this.$popup.open(waterWayDetail, this.dialogCompontent, this, {pageTitleName: "清洁运输水路运输功能列表",})
    },
    moreWaterWayMaterial() {
      this.$store.commit('dialogStatus', true)
      this.$store.commit('updateaWterWayTime', this.waterDate)
      this.$popup.open(waterWayPage, this.dialogCompontent, this, {})
    },
    openBeltwayLedger() {
      this.$store.commit('dialogStatus', true)
      this.$store.commit('updateBeltwayTime', this.beltWayDate)
      this.$popup.open(beltWayDetail, this.dialogCompontent, this, {pageTitleName: "清洁运输带式运输功能列表",})
    },
    pickerOptions(time) {
      if (this.customerId == 1414) {
        return time.getTime() > new Date().getTime() || new Date('2021-07-01 00:00:00').getTime() > time.getTime()
      } else {
        return time.getTime() > new Date().getTime()
      }
    },
    Tooltip(e) {
      this.currentHover = e.target.innerText
      this.currentLeft = `${e.target.offsetParent.offsetLeft + 50}px`
      this.currentTop = `${e.target.offsetParent.offsetTop}px`
      this.showTooltip = true
    },
    hideTooltip() {
      this.currentHover = ''
      this.currentLeft = ''
      this.currentTop = ''
      this.showTooltip = false
    },
    toolTip_Water(e) {
      clearTimeout(this.enterTimer2)
      this.currentHover = e.target.innerText
      this.currentLeft = `${e.target.offsetLeft + 50}px`
      this.currentTop = `${e.target.offsetTop}px`
      this.showTooltip_water = true
    },
    hideTooltip_Water() {
      setTimeout(() => {
        if (!this.isEnterTooltip) {
          this.showTooltip_water = false
          this.currentHover = ''
          this.currentLeft = ''
          this.currentTop = ''
        }
      }, 300)
    },
    waterTolltipEnterEvent() {
      this.isEnterTooltip = true
      clearTimeout(this.enterTimer)
    },
    waterTolltipOutEvent() {
      this.enterTimer = setTimeout(() => {
        this.isEnterTooltip = false
      }, 100)
      this.enterTimer2 = setTimeout(() => {
        this.showTooltip_water = false
      }, 100)
    },
    refresh() {
      if (this.clock) {
        clearTimeout(this.clock)
        this.clock = null
      }
      this.getTransportType()
      this.getTransportCount()
      this.clock = setTimeout(() => {
        this.refresh()
      }, 30 * 1000)
    },
    async railwayRefresh() {
      if (this.railwayClock) {
        clearTimeout(this.railwayClock)
        this.railwayClock = null
      }
      await this.getRailwayCount()
      if (this.railway_transportCount.length > 1) {
        this.railwayClock = setTimeout(() => {
          this.railwayRefresh()
        }, 30 * 1000)
      }
    },
    async beltwayRefresh() {
      if (this.beltWayClock) {
        clearTimeout(this.beltWayClock)
        this.beltWayClock = null
      }
      await this.getBeltWayCount()
      if (this.beltWay_transportCount.length > 1) {
        this.beltWayClock = setTimeout(() => {
          this.beltwayRefresh()
        }, 30 * 1000)
      }
    },
    async waterWayRefresh() {
      if (this.waterWayClock) {
        clearTimeout(this.waterWayClock)
        this.waterWayClock = null
      }
      await this.getWaterwayCount()
      if (this.waterway_transportCount.length > 1) {
        this.waterWayClock = setTimeout(() => {
          this.waterWayRefresh()
        }, 30 * 1000)
      }
    },

    showMarquee() {
      this.animate = true
      setTimeout(() => {
        this.factory_transportCount.push(this.factory_transportCount[0])
        this.factory_transportCount.shift()
        this.animate = false
      }, 3000)
    },
    showRailwayMarquee() {
      this.trainAnimate = true
      setTimeout(() => {
        this.railway_transportCount.push(this.railway_transportCount[0])
        this.railway_transportCount.shift()
        this.trainAnimate = false
      }, 3000)
    },
    showBeltwayMarquee() {
      this.beltAnimate = true
      setTimeout(() => {
        this.beltWay_transportCount.push(this.beltWay_transportCount[0])
        this.beltWay_transportCount.shift()
        this.beltAnimate = false
      }, 3000)
    },
    startMarquee() {
      this.interVal = setInterval(this.showMarquee, 5000)
    },
    startRailwayMarquee() {
      if (this.railway_transportCount.length > 1) {
        this.railwayInterVal = setInterval(this.showRailwayMarquee, 5000)
      }
    },
    startBeltWayMarquee() {
      if (this.beltWay_transportCount.length > 1) {
        this.beltWayInterVal = setInterval(this.showBeltwayMarquee, 5000)
      }
    },
    stopMarquee() {
      if (this.interVal) {
        clearInterval(this.interVal)
      }
    },
    async getTransportType() {
      let url = this.cleanTransportIp + '/transport/transport_type'
      let res
      
      if (this.cleanDate_ && this.cleanDate_.length > 0) {
        res = await this.$apiUtils.get3(url, {
          customerId: this.customerId,
          startTime: this.cleanDate_[0],
          endTime: this.cleanDate_[1] ? this.cleanDate_[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
        })
        console.log('res', res)
      } else {
        res = await this.$apiUtils.get3(url, {
          customerId: this.customerId
        })
      }
      if (!(res.length > 0)) {
        return
      }
      const _this = this
      if(this.customerId === 11){
        res = bmeConfig.jintangCleanTransportData
      }
      _this.factory_tPercent = res
      _this.factory_transportPercent = []
      if (_this.customerId == "50") {
        let total = 0;
        res.forEach(item => {
          if (item.type == "新能源" || item.type == "带式运输" || item.type == "水路运输") {
            total = total + item.percentage * 1
          }
        })
        total = total.toFixed(2)
        if(res.length == 2) {
          _this.topBylength = "topTwo"
        } else if(res.length == 3) {
          _this.topBylength = ""
        }
        this.cleanTransportTotal = total
      }
      res.forEach((type, i) => {
        _this.factory_transportPercent.push({
          value: type.percentage,
          name: type.type,
          unit:'%',
          itemStyle: {
            color: _this.getColor_(i)
          }
        })
      })
      this.$nextTick(() => {
        if (this.customerId !== 6 && this.customerId !== 11) {
          if (!this.factoryPieChart) {
            this.factoryPieChart = echarts.init(this.$refs.factoryPieChart)
          }
          this.factoryPieChart.setOption(getPieSeries(this.factory_transportPercent),true)
          console.log('this.factory_transportPercent', this.factory_transportPercent)
        } else {
          if (!this.factoryBarChart) {
            this.factoryBarChart = echarts.init(this.$refs.factoryBarChart)
          }
          this.factoryBarChart.setOption(getBarSeries(this.factory_transportPercent),true)
        }
      })
    },

    async getTransportCount() {
      // CONFIG.newName
      let url = this.cleanTransportIp + '/transport/transport_count'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        startTime: this.cleanDate_ && this.cleanDate_[0],
        endTime: this.cleanDate_ && this.cleanDate_[1] ? this.cleanDate_[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      })
      if (!(res.length > 0)) {
        return
      }
      this.stopMarquee()
      this.factory_transportCount = res
      if (!this.interVal && this.customerId !== 35) {
        this.startMarquee()
      }
    },
    async getRailwayCount() {
      // CONFIG.newName
      let url = this.cleanTransportIp + '/transport/train/statistics'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        startTime: this.railwayDate_ && this.railwayDate_[0],
        endTime: this.railwayDate_ && this.railwayDate_[1] ? this.railwayDate_[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      })
      if (!(res.length > 0)) {
        return
      }

      this.railway_transportCount = res
      if (res.length > 1) {
        this.railwayDateTime()
      }
      this.stopRailwayMarquee()
      if (!this.railwayInterVal && this.customerId !== 35) {
        this.startRailwayMarquee()
      }
    },
    async getWaterwayCount() {
      this.waterway_transportCount = []
      // CONFIG.newName
      let url = this.cleanTransportIp + '/transport/waterway/statistics/summary'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        startTime: this.waterDate_ && this.waterDate_[0],
        endTime: this.waterDate_ && this.waterDate_[1] ? this.waterDate_[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      })
      if (!(res && res.length > 0)) {
        return
      }
      this.waterway_transportCount = res
      // if (res.length > 1) {
      //   this.railwayDateTime();
      // }
      // this.stopRailwayMarquee();
      // if (!this.railwayInterVal && this.customerId !== 35) {
      //   this.startRailwayMarquee();
      // }
    },
    async getBeltWayCount() {
      this.beltWay_transportCount = []
      // CONFIG.newName
      let url = this.cleanTransportIp + '/transport/crawler/statistics'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        startTime: this.beltDate_ && this.beltDate_[0],
        endTime: this.beltDate_ && this.beltDate_[1] ? this.beltDate_[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      })
      if (!(res && res.length > 0)) {
        return
      }
      this.beltWay_transportCount = res
    },
    stopRailwayMarquee() {
      clearInterval(this.railwayInterVal)
    },
    stopBeltwayMarquee() {
      clearInterval(this.beltWayInterVal)
    },
    async getInoutCount() {
      let url = this.cleanTransportIp + '/transport/inout_count'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        startTime: this.cleanDate_[0],
        endTime: this.cleanDate_[1] ? this.cleanDate_[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      })
      if (!(res.length > 0)) {
        return
      }
      const _this = this
      res.forEach(inout => {
        switch (inout.vehicleEmissions) {
          case VEHICLE_EMISSIONS.emissions6:
            _this.vehicle6InoutCount = inout.num
            break
          case VEHICLE_EMISSIONS.emissions5:
            _this.vehicle5InoutCount = inout.num
            break
          case VEHICLE_EMISSIONS.newSource:
            _this.newSourceInoutCount = inout.num
            break
        }
      })
    },
    async getTransportAllType() {
      let url = this.cleanTransportIp + '/statistic/transport_type'
      if (this.customerId == 94 || this.customerId == 60 || this.customerId == 48 || this.customerId == 40) {
        url = this.cleanTransportIp + '/transport/transport_type'
      }
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        startTime: this.baseTime[0],
        endTime: this.baseTime[1] ? this.baseTime[1] : dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
      })
      if (res) {
        this.transportLength = res.length
        if(this.transportLength<2 && !bmeConfig.showTotalTransport){
            this.chooseBtn = 2
            this.selectTab(2)
        }
      
        this.allfactory_tPercent = res
        this.allfactory_transportPercent = []
        res.forEach((type, i) => {
          this.allfactory_transportPercent.push({
            value: this.customerId == 125 ? type.transportVolume : type.percentage,
            name: type.trafficTypeName,
            itemStyle: {
              color: this.getColor_(i)
            }
          })
        })
        this.$nextTick(() => {
          if (this.$refs.allfactoryBarChart) {
            this.allfactoryBarChart = echarts.init(this.$refs.allfactoryBarChart)
            this.allfactoryBarChart.clear()
          }
          if(bmeConfig.isnewVesionTansDetail) {
            if (this.customerId == 110) {
              this.allfactoryBarChart.setOption(
                getPieSeries(this.allfactory_transportPercent, true, {
                  x: '15%',
                  y: '50%'
                })
              )
            } else if (this.customerId == 125) {
              this.allfactoryBarChart.setOption(getPieSeries2(this.allfactory_transportPercent, true))
            } else {
              this.allfactoryBarChart.setOption(
                getPieSeries(this.allfactory_transportPercent, true, {
                  x: '60%',
                  y: '60%'
                },["40%","90%"])
              )
            }
          } else if (this.customerId == 64) {
            this.allfactoryBarChart.setOption(
              getPieSeries(this.allfactory_transportPercent, true, {
                x: '20%',
                y: '40%'
              })
            )
          } else {
            this.allfactoryBarChart.setOption(getPieSeries(this.allfactory_transportPercent, true,{
              x: "60%",
              y: "60%"
            }))
          }
        })
      }
    },
    async getCarListInFactory() {
      let url = this.cleanTransportIp + '/in_factory/list'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        keyword: this.params.keyword,
        vehicleEmissions: this.params.vehicleEmissions,
        pageNo: this.page.pageNum,
        pageSize: this.page.pageSize
      })
      this.factoryData = res.list.length > 3 ? res.list.slice(0, 3) : res.list
      this.showFactoryTable = true
    },
    async getCarListNonMovement() {
      let url = this.cleanTransportIp + '/no_road/list'
      let res = await this.$apiUtils.get3(url, {
        customerId: this.customerId,
        keyword: this.params.keyword,
        vehicleEmissions: this.params.vehicleEmissions,
        pageNo: this.page.pageNum,
        pageSize: this.page.pageSize
      })
      this.nonMovementData = res.list.length > 3 ? res.list.slice(0, 3) : res.list
    },
    getColor(i) {
      let colorList = ['#F6836E', '#FF9F4B', '#F6CE6E', '#F0681C', '#0188CC', '#025FBA', '#042E93']
      let color = colorList[i % 7]
      return color
    },
    getColor_(i) {
      let colorList = ['#00AEFF', '#FFB400', '#3CC93C', '#3300ff']
      let color = colorList[i % 4]
      return color
    },
    factoryRowClick(row) {
      this.$store.commit('dialogStatus', true)
      this.$popup.open(basic, this.dialogCompontent, this, {
        type: 'factory',
        number: row.numberPlate
      })
      this.$store.commit('setCloseTransportVideo', new Date().getTime())
    },
    nonMovementRowClick(row) {
      this.$store.commit('dialogStatus', true)
      this.$popup.open(basic, this.dialogCompontent, this, {
        type: 'nonMovement',
        number: row.environmentCode
      })
      this.$store.commit('setCloseTransportVideo', new Date().getTime())
    },
    gotoList() {
      let path = ''
      switch (this.choosedAccount) {
        case this.carAccountType.inFactory:
          // path = "/accountDialog/accountListInFactory";
          this.$store.commit('dialogStatus', true)
          this.$popup.open2(accountListInFactory, this.dialogCompontent, this,{
            pageTitleName: "清洁运输非道路移动机械电子台账展示功能"
          })
          break
        case this.carAccountType.nonMovement:
          // path = "/accountDialog/accountListNonmove";
          this.$store.commit('dialogStatus', true)
          this.$popup.open2(accountListNonmove, this.dialogCompontent, this,{
            pageTitleName: "清洁运输场内运输车辆电子台账展示功能"
          })
          break
      }
      this.$router.push({
        path: path,
        query: {
          type: this.choosedAccount
        }
      })
    },
    searchCountClean() {
      this.getTransportType()
      this.getTransportCount()
      // this.getInoutCount();
      // this.getCarListInFactory();
    },
    searchRailwayClean() {
      this.getRailwayCount()
    },
    searchWaterwayClean() {
      this.getWaterwayCount()
    },
    searchBeltWayClean() {
      this.getBeltWayCount()
    },
    resetAllForm() {
      this.baseTime = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]

      if (this.customerId == 54) {
        // 获取当前日期
        let today = new Date()

        // 获取前一天的日期
        let yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)
        this.baseTime = [
          dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00',
          dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
        ]
      }
      if (this.customerId == 41) {
        this.baseTime = [dateFormat('YYYY-mm-dd HH:MM:SS', new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30)), dateFormat('YYYY-mm-dd HH:MM:SS', new Date())];
      }
      this.getTransportAllType()
    },
    resetCleanForm() {
      this.createTime = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.cleanDate = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.cleanDate_ = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', '']

      if (this.customerId == 54) {
        // 获取当前日期
        let today = new Date()

        // 获取前一天的日期
        let yesterday = new Date(today)
        yesterday.setDate(today.getDate() - 1)

        this.createTime = [
          dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00',
          dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
        ]

        this.cleanDate = [
          dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00',
          dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
        ]
        this.cleanDate_ = [dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00', '']
      }
      if (this.customerId == 41) {
        this.createTime = this.cleanDate_ = [dateFormat('YYYY-mm-dd HH:MM:SS', new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 30)), dateFormat('YYYY-mm-dd HH:MM:SS', new Date())];
      }

      this.getTransportType()
      this.getTransportCount()
      // this.getInoutCount();
      // this.getCarListInFactory();
    },
    resetRailwayForm() {
      this.railwayDate = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.railwayDate_ = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', '']
      this.getRailwayCount()
    },
    resetWaterWayForm() {
      this.waterDate = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.waterDate_ = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', '']
      this.getWaterwayCount()
    },
    resetBeltWayForm() {
      this.beltDate = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.beltDate_ = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', '']
      this.getBeltWayCount()
    },
    searchCarAccount() {
      switch (this.choosedAccount) {
        case this.carAccountType.inFactory:
          this.getCarListInFactory()
          break
        case this.carAccountType.nonMovement:
          this.getCarListNonMovement()
          break
      }
    },
    resetCarForm() {
      this.params = {
        keyword: '',
        vehicleEmissions: ''
      }
      this.searchCarAccount()
    },
    base_change(e) {
      this.baseTime = e
    },
    /**
     * @Description: 获取前三个月日期
     * @param {String} time 时间
     * @return String
     * @author liqiuyu
     * @date 2024/1/5
     */
    getThreeMonthDay(time) {
      let currentTime = Date.parse(time.replace(/-/g, '/'))
      let monthMap = {
        1: 31,
        2: 28,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31
      }
      let oneDay = 1000 * 60 * 60 * 24
      let currentMonth = new Date().getMonth() + 1
      let currentYear = new Date().getFullYear()
      let lastmonthDay = 0
      let preMonthDay = 0
      let preSecDay = 0
      if (currentMonth == 1) {
        preMonthDay = monthMap[12]
        preSecDay = monthMap[11]
      } else {
        preMonthDay = monthMap[currentMonth - 1]
        if (currentMonth - 2 == 0) {
          preSecDay = monthMap[12]
        } else {
          preSecDay = monthMap[currentMonth - 2]
        }
      }
      let lastBigTime = new Date().getTime() - oneDay * (monthMap[currentMonth] + preSecDay + preMonthDay)
      if (lastBigTime > currentTime) {
        return moment(lastBigTime).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return time
      }
    },
    date_change(e) {
      if (this.customerId == 58) {
        e[0] = this.getThreeMonthDay(e[0])
      }
      //this.cleanDate = e;
      this.createTime = e
      this.cleanDate = e
      this.cleanDate_ = this.cleanDate
    },
    time_change(e) {
      this.railwayCreateTime = e
      this.railwayDate = e
      this.railwayDate_ = this.railwayDate
    },
    waterTime_change(e) {
      this.waterwayCreateTime = e
      this.waterDate = e
      this.waterDate_ = this.waterDate
    },
    beltTime_change(e) {
      this.beltDate = e
      this.beltDate_ = this.beltDate
    },
    timeFocus() {
      this.isFocus = true
    },
    timeBlur() {
      this.isFocus = false
    },
    railwayDateTime() {
      this.railwayTimer = setInterval(() => {
        if (this.railwayDate_ && !this.railwayDate_[1] && !this.isFocus) {
          this.railwayDate[1] = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
        }
      }, 5000)
    },
    formatDateTime(inputTime) {
      inputTime = parseInt(inputTime)
      if (inputTime) {
        var date = new Date(inputTime)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d
        var h = date.getHours()
        h = h < 10 ? '0' + h : h
        var minute = date.getMinutes()
        var second = date.getSeconds()
        minute = minute < 10 ? '0' + minute : minute
        second = second < 10 ? '0' + second : second
        return y + '-' + m + '-' + d
      }
    }
  },
  mounted() {
    if (this.electricVehicle) {
      this.vehicleMissionsType.push({
        label: '纯电',
        value: 199
      })
      this.vehicleMissionsName['199'] = '纯电'
    }

    if (this.newAccessType) {
      this.carAccountType.inFactory = '厂内运输车辆电子台账'
      this.choosedAccount = '厂内运输车辆电子台账'
    }

    if (this.customerId == 54) {
      // 获取当前日期
      let today = new Date()

      // 获取前一天的日期
      let yesterday = new Date(today)
      yesterday.setDate(today.getDate() - 1)
      this.baseTime = [
        dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00',
        dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
      ]

      this.createTime = [
        dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00',
        dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
      ]

      this.cleanDate = [
        dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00',
        dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
      ]
      this.cleanDate_ = [dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 00:00:00', '']
    }

    if (this.customerId != 41 && this.customerId != 64 && this.customerId != 81 && !this.isWaterWayTransport) {
      this.chooseBtn = 2
      this.showTransportType = 2
    }
    if (this.customerId == 126 || this.customerId == 58) {
      this.chooseBtn = 2
      this.showTransportType = 2
    }
    // this.app.cleanTransportIp = "http://192.168.1.37:9110/bme-access-control"; //记得注释
    this.transportHeight = this.$refs.rightBlock ? $(this.$refs.rightBlock).height() : 200
    this.refresh()
    // this.getInoutCount();
    this.getTransportAllType()
    this.getCarListInFactory()
    this.getCarListNonMovement()

    if (this.dateTimer) {
      clearInterval(this.dateTimer)
    }
    if (this.railwayTimer) {
      clearInterval(this.railwayTimer)
    }
    this.dateTimer = setInterval(() => {
      if (this.cleanDate_ && !this.cleanDate_[1] && !this.isFocus) {
        if (this.customerId == 54) {
          let today = new Date()

          // 获取前一天的日期
          let yesterday = new Date(today)
          yesterday.setDate(today.getDate() - 1)
          this.cleanDate[1] = dateFormat('YYYY-mm-dd', new Date(yesterday)) + ' 23:59:59'
        } else {
          this.cleanDate[1] = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
        }
      }
    }, 5000)
    this.resetCarForm()
  },

  beforeUnmount() {
    if (this.clock) {
      clearTimeout(this.clock)
    }
    if (this.railwayClock) {
      clearTimeout(this.railwayClock)
    }
    if (this.railwayInterVal) {
      clearTimeout(this.railwayInterVal)
    }
    if (this.beltWayClock) {
      clearTimeout(this.beltWayClock)
    }
    this.railwayClock = null
    this.beltWayClock = null
    this.railwayInterVal = null
    this.clock = null
    if (this.interVal) {
      clearInterval(this.interVal)
    }
    if (this.dateTimer) {
      clearInterval(this.dateTimer)
    }
    this.interVal = null
    if (this.factoryBarChart) {
      this.factoryBarChart.dispose()
      this.factoryBarChart = null
    }
    if (this.factoryPieChart) {
      this.factoryPieChart.dispose()
      this.factoryPieChart = null
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.up_down_box {
  &.isBaoSteelClass {
    margin-left: 20px;
  }
}

.tab_btn {
  background-image: url('./img/btn.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  width: 90px;
  height: 38px;
  margin-right: 8px;
  line-height: 38px;
  display: inline-block;
  cursor: pointer;
  font-size: 18px !important;
}

.other_btn {
  display: inline-block;
  width: 86px;
  height: 34px;
  background: url('./img/but_other.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 4px;
  font-size: 18px;
  margin-right: 8px;
  color: #fff;
  // margin-left: 10px;
  line-height: 34px;
  text-align: center;
  // &:hover {
  //   background: url('/static/img/popupImg/but_other_df.png') no-repeat center center;
  //   background-size: 100% 100%;
  // }
}

.chooseBtn {
  background-image: url('./img/btn_click.png');
}

.up_box,
.down_box {
  height: 385px;
  padding: 20px;
  @include bg-box(100%, 385px, 'rightSmall.png');

  &.isBaoSteel {
    background: #020f3f;
  }

  &.isStrong {
    @include bg-box(100%, 385px, 'right_strong.png');
  }
}

.up_box {
  margin-bottom: 20px;
}

.door_title {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
}

.up_box .door-box,
.down_box .door-box {
  height: 313px !important;
}

.form {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box-wrap {
  height: 100%;
  padding: 40px 30px 0 30px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;

  .left {
    position: relative;
    width: 44%;
    .limit-width{
      width:70% !important;
    }
    .count {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .download-link{
        position: absolute;
        left:0;
        top:0;
        height:50%;
        width:70%;
        z-index:3;
      }
      .allTitle {
        width: 82%;
        text-align: center;
        font-size: 22px;
      }

      .allTitle-64 {
        text-align: left;
        padding-left: 140px;
      }

      .c-desc {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;

        .desc-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 24px;
          color: white;

          .block {
            margin: 0 5px;
            width: 14px;
            height: 10px;
          }
        }
      }
    }

    .factory-chart {
      margin-left: -55%;
      margin-top: -13%;
      width: 150%;
      height: 150%;
    }

    .factory-bar-chart {
      width: 100%;
      height: 280px;
    }

    .allfactory-bar-chart {
      width: 50%;
      height: 260px;
      margin-top: -6%;
      margin-left:-5%;
    }
    .bigWidthChart {
      width: 300% !important;
    }

    .line {
      position: absolute;
      top: 50%;
      right: 154px;
      width: 23%;
      height: 1px;
      background-color: white;
    }

    .chart-desc {
      position: absolute;
      right: 30px;
      bottom: 23%;
      display: flex;
      // flex-direction: column;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 250px;
      box-sizing: border-box;

      .desc-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 40px;
        font-size: 24px;
        color: white;

        .block {
          margin-right: 5px;
          width: 14px;
          height: 10px;
        }
      }

      .desc-item-64 {
        width: 500px;
      }

      .desc-item:last-child {
        width: 100%;
      }
    }

    .chart-desc-64 {
      width: 500px;
    }

    .allchart-desc {
      right: 400px;
      top: 80px !important;
    }
  }

  .right {
    width: 55%;
    box-sizing: border-box;
    position: relative;

    .chapter {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .values {
        display: flex;
        justify-content: space-between;
        width: 50%;

        .standard-name {
          margin-right: 10px;
          font-size: 20px;
          color: rgba(0, 174, 255, 1);
          line-height: 26px;
        }

        .val {
          font-size: 28px;
          font-family: Jost-Italic, Jost;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          line-height: 40px;
          text-shadow: 0px 0px 16px rgba(0, 102, 255, 1);
        }
      }
    }

    .car-chart {
      margin-top: -20px;
      width: 100%;
      height: 105%;
    }

    .marquee_box {
      display: block;
      position: relative;
      width: 100%;
      height: 67%;
      overflow-y: hidden;
    }

    .tool-tip {
      position: absolute;
      padding: 10px;
      display: block;
      // min-width: 100px;
      max-width: 600px;
      // width: 600px;
      font-size: 20px;
      text-align: center;
      color: white;
      background-color: rgba(0, 0, 0, 0.9);
      // overflow: hidden;
      transform: translateY(-50%);
      z-index: 99;
      overflow-y: auto;
    }

    .marquee_list {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .marquee_top {
      transition: all 0.5s;
      margin-top: -66px;
    }

    .transport-counts {
      .transport-header {
        display: flex;
        justify-content: space-between;
        font-size: 22px;
        color: #00aeff;
        line-height: 34px;
        border-bottom: 1px solid rgba(186, 239, 255, 0.4);

        .method {
          width: 20%;
        }

        .num {
          width: 20%;
        }

        .goods {
          width: 40%;
        }

        .count {
          width: 20%;
        }
      }

      .transport-body {
        position: relative;
        padding: 16px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 20px;
        line-height: 34px;
        border-bottom: 1px solid #baefff;

        .method,
        .number,
        .goods,
        .count {
          position: relative;
          height: 34px;

          .content {
            display: block;
            width: 100%;
            height: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .method {
          width: 20%;
        }

        .number {
          width: 20%;
        }

        .goods {
          padding: 0 10px 0 0;
          width: 40%;
          color: white;
          box-sizing: border-box;
        }

        .count {
          width: 20%;
          color: #90dcff;
        }
      }
    }
  }

  .center_block {
    width: 100%;
    box-sizing: border-box;
    position: relative;

    .chapter {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .values {
        display: flex;
        justify-content: space-between;
        width: 50%;

        .standard-name {
          margin-right: 10px;
          font-size: 20px;
          color: rgba(0, 174, 255, 1);
          line-height: 26px;
        }

        .val {
          font-size: 28px;
          font-family: Jost-Italic, Jost;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          line-height: 40px;
          text-shadow: 0px 0px 16px rgba(0, 102, 255, 1);
        }
      }
    }

    .car-chart {
      margin-top: -20px;
      width: 100%;
      height: 105%;
    }

    .marquee_box {
      display: block;
      position: relative;
      width: 100%;
      height: 67%;
      overflow-y: hidden;
    }

    .tool-tip {
      position: absolute;
      padding: 10px;
      display: block;
      // min-width: 100px;
      max-width: 600px;
      // width: 600px;
      font-size: 20px;
      text-align: center;
      color: white;
      background-color: rgba(0, 0, 0, 0.9);
      // overflow: hidden;
      transform: translateY(-50%);
      z-index: 99;
      overflow-y: auto;
    }

    .marquee_list {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .marquee_top {
      transition: all 0.5s;
      margin-top: -66px;
    }

    .transport-counts {
      .transport-header {
        display: flex;
        justify-content: space-between;
        font-size: 22px;
        color: #00aeff;
        line-height: 34px;
        border-bottom: 1px solid rgba(186, 239, 255, 0.4);

        .vehicleEmissions {
          width: 15%;
        }

        .transportName {
          width: 40%;
        }

        .transportVolume {
          width: 15%;
        }

        .frequency {
          width: 15%;
        }

        .type {
          width: 15%;
        }

        .waterMethods {
          width: 15%;
        }

        .waterNames {
          width: 20%;
        }

        .waterTimes {
          width: 20%;
        }

        .waterContents {
          width: 40%;
        }

        .waterNums {
          width: 20%;
        }
      }

      .transport-body {
        position: relative;
        padding: 16px 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 20px;
        line-height: 34px;
        border-bottom: 1px solid #baefff;

        .vehicleEmissions,
        .transportName,
        .transportVolume,
        .frequency,
        .type,
        .waterMethods,
        .waterNames,
        .waterTimes,
        .waterContents,
        .waterNums {
          position: relative;
          height: 34px;

          .content {
            display: block;
            width: 100%;
            height: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .vehicleEmissions {
          width: 15%;
        }

        .transportName {
          padding: 0 10px 0 0;
          width: 38%;
          color: white;
          box-sizing: border-box;
        }

        .transportVolume {
          width: 15%;
        }

        .frequency {
          width: 15%;
        }

        .type {
          width: 15%;
          color: #90dcff;
        }

        .waterMethods {
          width: 15%;
        }

        .waterNames {
          width: 20%;
        }

        .waterTimes {
          width: 20%;
        }

        .waterContents {
          width: 40%;
        }

        .waterNums {
          width: 20%;
          color: #90dcff;
        }
      }
    }
  }
}

.up_down_box_green {
  @include bg-box(100%, 100%, 'right_green.png');
  padding: 10px;

  .up_box,
  .down_box {
    height: 375px;
    padding: 20px;
    background: none;
  }

  .up_box {
    margin-bottom: 0px;
  }
}

.up_down_box_blue {
  background: rgba(0, 106, 255, 0.05);
  border: 1px solid rgba(132, 170, 255, 0.5);

  .public-form {
    display: felx !important;
    align-items: center;
    height: 40px;
  }

  .up_box,
  .down_box {
    padding: 20px;
    background: none;
  }

  .door_title {
    height: 40px;
  }

  .self_btn {
    width: 120px;
    height: 40px;
    background: url('/static/img/popupImg/but_default.png') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 4px;
    font-size: 18px;
    color: #fff;
    margin-left: 20px;
    line-height: 40px;

    &:hover {
      background: url('/static/img/popupImg/but.png') no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="scss">
   .cleanTransportTotal {
    // position: absolute;
    // font-size: 24px;
    // left: 236px;
    // top: 58px;
    color: white;
    .p_block {
      .p_span {
        width: 16px;
        height: 10px;
        background: green;
        display: inline-block;
        margin-right: 2px;
        border: 1px solid #023b02;
      }
    }
    // font-weight: 600;
  }
.down_box .el-button {
  background: none;
  color: #fff !important;
}

.up_down_box_blue {
  .el-select .select-trigger .el-input .el-input__inner {
    height: 38px;
  }

  .el-input__suffix-inner {
    height: 38px;
    line-height: 38px;
  }

  .el-form .el-form-item {
    height: 38px !important;
    display: flex;
    align-items: center;
  }

  .public-form .el-input__inner {
    height: 38px !important;
  }

  .el-radio-button__inner {
    background: rgba(1, 18, 43, 0.81);
    color: #cdcdcd;
    border: 1px solid rgba(132, 170, 255, 0.5);
  }

  .el-table th.is-leaf,
  .el-table td {
    background: rgba(1, 18, 43, 0.81);
  }

  .input-style {
    margin-top: 11px !important;
  }
}
.left .smallTitle {
  position: relative;
  .cleanTransportTotal {
    position: absolute;
    font-size: 24px;
    left: 236px;
    top: 58px;
    color: white;
    .p_block {
      .p_span {
        width: 16px;
        height: 10px;
        background: green;
        display: inline-block;
        margin-right: 2px;
        border: 1px solid #023b02;
      }
    }
    // font-weight: 600;
  }

  .topTwo {
    top: 92px !important;
  }
}
/* .down_box .el-radio-button .el-radio-button__inner{
 background: #c0c4cc !important;
} */
</style>
